import type { TFieldKey } from "@./suf-store";
import { DirectSalesFlowSlug } from "../constants";
import type { RequiredFieldData } from "../../../shared/baseStore.types";

export const requiredFieldsBySlug: Record<
  DirectSalesFlowSlug,
  (data: RequiredFieldData) => TFieldKey[]
> = {
  [DirectSalesFlowSlug.AMBASSADOR]: () => [],
  [DirectSalesFlowSlug.CAT_DETAILS]: ({ cat, catId }) =>{

    const base: TFieldKey[] = [
      `cat[${catId}].gender`,
      `cat[${catId}].breed`,
      `cat[${catId}].lifeStage`,
      `cat[${catId}].age.mode`,
      `cat[${catId}].body.bodyType`,
      `cat[${catId}].body.activityLevel`,
      `cat[${catId}].medical.hasConditions`,
      `cat[${catId}].diet.foodAllergies.hasAllergies`,
    ];

    if (cat?.lifeStage === "kitten") {

      const ageMode = cat?.age?.mode ?? "months";
      if (ageMode === "weeks") {
        base.push(`cat[${catId}].age.weeks`);
      } else {
        base.push(`cat[${catId}].age.months`);
      }

    } else {
      // Birthday month is only required for adult/senior cats
      base.push(`cat[${catId}].birthdayMonth`, `cat[${catId}].age.years`);
    }

    if (cat?.medical?.hasConditions) {
      base.push(`cat[${catId}].medical.conditions`);
    }

    if (cat?.diet?.foodAllergies?.hasAllergies) {
      base.push(`cat[${catId}].diet.foodAllergies.allergens`);
    }

    return base;
  },

  [DirectSalesFlowSlug.CAT_PARENT_DETAILS]: () => [
    "firstName",
    "lastName",
    "email",
  ],

  [DirectSalesFlowSlug.CHECKOUT]: () => [
    "firstName",
    "lastName",
    "email",
    "shippingAddress.postcode",
    "shippingAddress.address1",
    "shippingAddress.city",
    "shippingAddress.province",
    "shippingAddress.phoneNumber",
    "billingAddress.postcode",
    "billingAddress.address1",
    "billingAddress.city",
    "billingAddress.countryCode",
    "billingAddress.phoneNumber",
    "deliveryDate",
  ],

  [DirectSalesFlowSlug.RECIPES]: ({ catId }) => [
    `cat[${catId}].viewedPlan`,
  ],
  [DirectSalesFlowSlug.CAT_COUNT]: () => [],
};
